export interface IApiResponse<T> {
  status: number;
  message: string;
  data: T;
  _metadata: IMetadataResponse;
}
type MetadataValue = string | number | boolean | null;
interface IMetadataResponse {
  language: string;
  timestamp: number;
  timezone: string;
  path: string;
  version: string;
  repoVersion: string;
  [key: string]: MetadataValue;
}
export interface IFieldSelectOrder {
  order: number;
  documentId: string;
}

export enum EValidationMessageKey {
  REQUIRE = "Required Field Validation",
  EMAIL_FORMAT = "Email Address Format Validation",
  PHONE_FORMAT = "Phone Format Validation",
  POSITIVE_NUMBER_FORMAT = "Positive Number Format Validation",
}

export enum EAppendAllAttraction {
  AREA = "Append Area",
  CITY = "Append City",
  NONE = "None",
}

export enum ESubmitStatus {
  IDLE = "idle",
  LOADING = "loading",
  SUCCESS = "success",
  ERROR = "error",
}
